// ==> General Navigation
export const ICON_INFO = 'bi:info-lg';
export const ICON_MENU = 'ic:twotone-menu-open';
export const ICON_VIDEO = 'ic:baseline-ondemand-video';
export const ICON_DOTS_MENU_DOTS = 'mdi:dots-vertical';

// ==> Directions
export const ICON_POINT_DOWN = 'material-symbols:keyboard-arrow-down-rounded';

// ==> General UI
export const ICON_SETTINGS = 'material-symbols:settings-rounded';
export const ICON_LOGOUT = 'humbleicons:logout';
export const ICON_CLOSE = 'ri:close-circle-line';
export const ICON_SEARCH = 'ic:outline-search';

// ==> Audio & Player
export const ICON_MUSIC_NOTES = 'ph:music-notes-light';

export const ICON_PLAY_BUTTON = 'material-symbols:play-circle';
export const ICON_PLAY_BUTTON_NO_ROUND = 'material-symbols:play-arrow';
export const ICON_PAUSE_BUTTON_NO_ROUND = 'ic:baseline-pause';

export const ICON_VOLUME = 'ic:round-volume-up';
export const ICON_VOLUME_MUTED = 'ic:round-volume-off';

// ==> Brands
export const ICON_INSTAGRAM = 'ph:instagram-logo';
export const ICON_SPOTIFY = 'ph:spotify-logo';
export const ICON_TWITTER = 'ph:twitter-logo';
export const ICON_FACEBOOK = 'ph:facebook-logo';
